export const BASE_IMAGE = 'https://pahtsonla-api.cgis.asia/';
export const PROCESSING_STEP_ID = {
    HANDLED: 5,
    COMPLETED: 8,
  };
